import { render, staticRenderFns } from "./AllowancesPlanDetailsDelete.vue?vue&type=template&id=5fbc9486&scoped=true&"
import script from "./AllowancesPlanDetailsDelete.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanDetailsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc9486",
  null
  
)

export default component.exports